import { render, staticRenderFns } from "./TourBikes.vue?vue&type=template&id=1b0f92e0&"
import script from "./TourBikes.vue?vue&type=script&lang=js&"
export * from "./TourBikes.vue?vue&type=script&lang=js&"
import style0 from "./TourBikes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourBikes.vue"
export default component.exports